<template>
    <section class="sambadrome-map">
        <div class="container">
            <figure>
                <img v-if="isOpened" v-bind:src="data.image" alt="Map" />
            </figure>

            <div class="button-wrapper">
                <button v-on:click="toggle" type="button">
                    <span>{{ isOpened ? data.buttons.hide : data.buttons.show }}</span>
                    <i class="fa" v-bind:class="{ 'fa-angle-up': isOpened, 'fa-angle-down': !isOpened }"></i>
                </button>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .sambadrome-map {
        padding-bottom: 30px;

        .container {
            position: relative;
            z-index: 1;
        }

        figure {
            margin: 0;
            padding: 0;
            width: 100%;

            img {
                width: 100%;
                padding: 0;
            }
        }

        .button-wrapper {
            display: block;
            margin: 0 auto;
            border-radius: 0 0 10px 10px;
            width: 30%;
            height: 45px;
            background: var(--color-purple-light);
            border: solid var(--color-purple-dark);
            border-width: 0 1px 1px 1px;
            position: relative;

            &.open .fa {
                transform: rotate(-180deg);
            }

            button {
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 50%;
                color: var(--color-purple-darker);
                text-align: center;
                width: 100%;
                height: 100%;
                cursor: pointer;
                font-weight: 800;
                font-size: 1.1rem;
                -webkit-appearance: none;
                background: transparent;
                border: 0;
                transform: translateY(-50%);

                &:hover {
                    color: var(--color-purple-dark);
                }
            }

            .fa {
                margin-left: .5rem;
                font-size: 1.5rem;
                transition: transform .2s ease;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                isOpened: false
            }
        },
        methods: {
            toggle: function(e) {
                this.isOpened = !this.isOpened
            }
        }
    }
</script>
